import {
  type AxiosRequestConfig,
  type EstimateNewOrderRequestBody,
  type EstimateNewOrderResponse,
  httpClient,
} from '@ahm/api-wrappers-core';
import { apiRoutes } from '../api-routes';

export const estimatedFeePartnerFn = async (
  body: EstimateNewOrderRequestBody,
  config: AxiosRequestConfig = {}
) => {
  const response = await httpClient.post<EstimateNewOrderResponse>(
    apiRoutes.order.estimatedFeePartner,
    body,
    config
  );
  return response.data;
};
